export type Currency = {
  code: string;
  name: string;
  nameAr: string;
  symbol: string;
  flag: string;
};

export const currencies: Currency[] = [
  { code: 'SAR', name: 'Saudi Riyal', nameAr: 'ريال سعودي', symbol: 'ر.س', flag: '🇸🇦' },
  { code: 'AED', name: 'UAE Dirham', nameAr: 'درهم إماراتي', symbol: 'د.إ', flag: '🇦🇪' },
  { code: 'QAR', name: 'Qatari Riyal', nameAr: 'ريال قطري', symbol: 'ر.ق', flag: '🇶🇦' },
  { code: 'KWD', name: 'Kuwaiti Dinar', nameAr: 'دينار كويتي', symbol: 'د.ك', flag: '🇰🇼' },
  { code: 'OMR', name: 'Omani Rial', nameAr: 'ريال عماني', symbol: 'ر.ع', flag: '🇴🇲' },
  { code: 'BHD', name: 'Bahraini Dinar', nameAr: 'دينار بحريني', symbol: 'د.ب', flag: '🇧🇭' },
  { code: 'IQD', name: 'Iraqi Dinar', nameAr: 'دينار عراقي', symbol: 'ع.د', flag: '🇮🇶' },
  { code: 'EGP', name: 'Egyptian Pound', nameAr: 'جنيه مصري', symbol: 'ج.م', flag: '🇪🇬' },
  { code: 'JOD', name: 'Jordanian Dinar', nameAr: 'دينار أردني', symbol: 'د.ا', flag: '🇯🇴' },
  { code: 'LBP', name: 'Lebanese Pound', nameAr: 'ليرة لبنانية', symbol: 'ل.ل', flag: '🇱🇧' },
  { code: 'SYP', name: 'Syrian Pound', nameAr: 'ليرة سورية', symbol: 'ل.س', flag: '🇸🇾' },
  { code: 'YER', name: 'Yemeni Rial', nameAr: 'ريال يمني', symbol: 'ر.ي', flag: '🇾🇪' },
  { code: 'DZD', name: 'Algerian Dinar', nameAr: 'دينار جزائري', symbol: 'د.ج', flag: '🇩🇿' },
  { code: 'MAD', name: 'Moroccan Dirham', nameAr: 'درهم مغربي', symbol: 'د.م', flag: '🇲🇦' },
  { code: 'TND', name: 'Tunisian Dinar', nameAr: 'دينار تونسي', symbol: 'د.ت', flag: '🇹🇳' },
  { code: 'LYD', name: 'Libyan Dinar', nameAr: 'دينار ليبي', symbol: 'ل.د', flag: '🇱🇾' },
  { code: 'SDG', name: 'Sudanese Pound', nameAr: 'جنيه سوداني', symbol: 'ج.س', flag: '🇸🇩' },
  { code: 'MRU', name: 'Mauritanian Ouguiya', nameAr: 'أوقية موريتانية', symbol: 'أ.م', flag: '🇲🇷' },
  { code: 'SOS', name: 'Somali Shilling', nameAr: 'شلن صومالي', symbol: 'ش.ص', flag: '🇸🇴' },
  { code: 'ILS', name: 'Israeli Shekel', nameAr: 'شيكل إسرائيلي', symbol: '₪', flag: '🇵🇸' },
  { code: 'KMF', name: 'Comorian Franc', nameAr: 'فرنك قمري', symbol: 'ف.ق', flag: '🇰🇲' },
  { code: 'USD', name: 'US Dollar', nameAr: 'دولار أمريكي', symbol: '$', flag: '🇺🇸' },
];

export function getCurrencyByCode(code: string): Currency | undefined {
  return currencies.find((c) => c.code === code);
}

export function formatCurrency(amount: number, currencyCode: string, language: 'en' | 'ar' = 'en'): string {
  console.log('formatCurrency called with:', { amount, currencyCode, language });
  
  const currency = getCurrencyByCode(currencyCode);
  console.log('Found currency:', currency);
  
  if (!currency) {
    return `${amount.toFixed(2)} ${currencyCode}`;
  }

  const formattedAmount = amount.toLocaleString(language === 'ar' ? 'ar-EG' : 'en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const result = language === 'ar'
    ? `${formattedAmount} ${currency.symbol}`
    : `${currency.symbol} ${formattedAmount}`;
  
  console.log('Formatted result:', result);
  return result;
}